import api from './api';

const cashService = {
  getAll: async () => {
    const response = await api.get('/cash');
    return response.data;
  },
  getSummary: async () => {
    const response = await api.get('/cash/summary');
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/cash', data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/cash/${id}`);
    return response.data;
  }
};

export default cashService;